import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, message, Button as AntButton, Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { CreditCardOutlined, FileAddOutlined, CloseOutlined } from '@ant-design/icons';
import { PAYMENT } from '../../api/EndPoints';
import { Helmet } from 'react-helmet';
import { createPaymentMethod, getPaymentMethod, makeDefaultCard, deleteCard } from '../../api';
import Paymentinput from '../elements/PaymentInput';
import { useForm } from 'react-hook-form';

const PaymentForm = (prop) => {
    const { token } = prop;
    const [cards, setCard] = useState([]);
    const [openPaymentForm, setOpenPaymentForm] = useState(false);
    const { handleSubmit } = useForm();
    const [addNew, setAddNew] = useState(false);
    const [load, setLoad] = useState(false);
    const loader = { load, setLoad };

    const addCard = useCallback(() => {
        message.loading('Loading');
        loader.setLoad(true);
        window.PaymentSession.updateSessionFromForm('card');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = (data) => {
        loader.setLoad(true);
        if (cards.length === 0 || addNew) {
            addCard();
        }
    };

    const refreshPayment = useCallback(() => {
        if (token) {
            getPaymentMethod({ token }).then((response) => {
                setCard(response.cards);
                if (response.cards.length === 0) {
                    setOpenPaymentForm(true);
                }
            });
        }
    }, [token]);

    const addPaymentSuccess = (card) => {
        setCard([...cards, card]);
        if (addNew) {
            setAddNew(false);
        }
    };

    const handleDeleteCard = useCallback(
        (id) => {
            Modal.confirm({
                title: 'Remove the card',
                content: 'Are you sure want to remove the payment card?',
                okText: 'Remove',
                cancelText: 'No',
                onOk: () => {
                    const hide = message.loading('Removing payment card...');
                    deleteCard({ token, id })
                        .then((response) => {
                            hide();
                            message.success(response?.data?.message);
                            setCard(response.data.data);
                        })
                        .catch((error) => {
                            hide();
                            message.error(error?.response?.data?.message);
                        });
                },
            });
        },
        [token]
    );

    useEffect(() => {
        refreshPayment();
    }, [refreshPayment]);

    const handleCreateDefaultCard = (id) => {
        Modal.confirm({
            title: 'Do you want to change default card?',
            content: 'This card will change to default card for your next payment?',
            onOk: () => {
                makeDefaultCard({ token, id })
                    .then((response) => {
                        message.success('Successful make default.');
                        refreshPayment();
                    })
                    .catch((error) => {
                        if (error) {
                        }
                    });
            },
        });
    };

    const getCardStyle = (type) => {
        switch (type) {
            case 'VISA':
                return 'visa';
            case 'MASTERCARD':
                return 'master';
            default:
                return 'jcb';
        }
    };

    return (
        <div className="formStatus">
            <form onSubmit={handleSubmit(onSubmit)} className="payment-information-form ">
                <div className="payment-information-label-container">
                    <CreditCardOutlined className="payment-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">Payment Information</h4>
                    {cards.length !== 0 && (
                        <AntButton
                            id="payment-add-new"
                            style={{ float: 'right' }}
                            type="default"
                            icon={!addNew ? <FileAddOutlined /> : <CloseOutlined />}
                            onClick={() => setAddNew(!addNew)}
                        />
                    )}
                </div>
                {cards.length > 0 ? (
                    <div className="payment-card-container">
                        {cards.map((card, key) => {
                            return (
                                <div className={`payment-card ${getCardStyle(card.brand)}`} key={key}>
                                    {/* <h4 className="cardNumber">{card.issuers}</h4> */}
                                    {card.is_primary === 0 && (
                                        <AntButton
                                            type="default"
                                            className="cardDeleteButton"
                                            icon={<DeleteOutlined />}
                                            onClick={() => handleDeleteCard(card.id)}
                                        />
                                    )}

                                    <h3 className="cardNumber">{card.number}</h3>
                                    <div className="cardDateBrand">
                                        <div className="cardExpiry">Expiry Date </div>
                                        <div className="cardDate">{card.expiry_date}</div>
                                    </div>

                                    <div className="cardTypeDafault">
                                        <div className="cardType">{card.funding_method}</div>
                                        {card.is_primary === 0 ? (
                                            <div
                                                className="cardDefault createDefaultCard"
                                                onClick={() => handleCreateDefaultCard(card.id)}
                                            >
                                                Use as Default
                                            </div>
                                        ) : (
                                            <div className="cardDefault">Default Card</div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    [
                        openPaymentForm && (
                            <PaymentSessionForm
                                token={token}
                                addNew={true}
                                refreshPayment={addPaymentSuccess}
                                loader={loader}
                            />
                        ),
                    ]
                )}
                {addNew && (
                    <PaymentSessionForm
                        token={token}
                        addNew={addNew}
                        loader={loader}
                        refreshPayment={addPaymentSuccess}
                    />
                )}
                <div className="subscriptionContentContainerSteps">
                    {/* <MuiButton onClick={() => onBack()} className="secondary-btn profilePrev">back</MuiButton> */}
                    {/* {addNew && ( */}
                    {/* <MuiButton className="secondary-btn profileNext" type="submit">
              save
            </MuiButton> */}
                    <AntButton
                        id="payButton"
                        loading={loader.load}
                        className="secondary-btn profileNext"
                        htmlType="submit"
                    >
                        SAVE
                    </AntButton>
                    {/* )} */}
                </div>
            </form>
        </div>
    );
};

function loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) {
        //IE
        script.onreadystatechange = function () {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        //Others
        script.onload = function () {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}

const PaymentSessionForm = (props) => {
    const { token, addNew, refreshPayment, loader } = props;

    const configPaymentSession = useCallback(() => {
        if (token) {
            message.loading('Payment Loading...');
            loader.setLoad(true);
            loadScript(PAYMENT, () => {
                window.PaymentSession.configure({
                    fields: {
                        card: {
                            number: '#card-number',
                            securityCode: '#security-code',
                            expiryMonth: '#expiry-month',
                            expiryYear: '#expiry-year',
                            nameOnCard: '#cardholder-name',
                        },
                    },
                    frameEmbeddingMitigation: ['javascript'],
                    callbacks: {
                        initialized: function (response) {
                            loader.setLoad(false);
                        },
                        formSessionUpdate: function (response) {
                            loader.setLoad(false);
                            if (response.status) {
                                if ('ok' === response.status) {
                                    createPaymentMethod({
                                        token,
                                        session_id: response.session.id,
                                    })
                                        .then((response) => {
                                            message.success(response?.data?.message);
                                            refreshPayment(response?.data?.data);
                                            loader.setLoad(false);
                                        })
                                        .catch((error) => {
                                            if (error?.response?.status === 422) {
                                                Modal.error({
                                                    title: 'Payment Card Error',
                                                    content: error?.response?.data?.message,
                                                });
                                            }
                                        });
                                } else {
                                    const isFieldError = 'fields_in_error' === response.status;
                                    if (isFieldError) {
                                        if (response.errors.cardNumber) {
                                            document.getElementById('cardNumber').innerHTML =
                                                'Card number invalid or missing';
                                        }
                                        if (response.errors.expiryYear) {
                                            document.getElementById('expiryYear').innerHTML = 'Missing expiry year.';
                                        }
                                        if (response.errors.expiryMonth) {
                                            document.getElementById('expiryMonth').innerHTML = 'Missing expiry month.';
                                        }
                                        if (response.errors.securityCode) {
                                            document.getElementById('securityCode').innerHTML =
                                                'Missing security code.';
                                        }
                                    }
                                }
                            }
                        },
                    },
                    interaction: {
                        displayControl: {
                            formatCard: 'EMBOSSED',
                            invalidFieldCharacters: 'REJECT',
                        },
                    },
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    useEffect(() => {
        configPaymentSession();
    }, [addNew, configPaymentSession]);

    return (
        <section>
            <Helmet>
                {/* <script  async defer src={PAYMENT} type="text/javascript"></script> */}
                <style id="antiClickjack">
                    {/* {`
           body {
             display:none !important;
            }
          `} */}
                </style>
            </Helmet>
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <Paymentinput
                        id="cardholder-name"
                        type="text"
                        label="Name on card"
                        aria_label="enter name on card"
                        placeholder="Enter name on card"
                        tab_index="1"
                    />
                </Col>
            </Row>

            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <Paymentinput
                        id="card-number"
                        type="text"
                        label="Card Number"
                        aria_label="enter your card number"
                        placeholder="Enter Card Number"
                        tab_index="2"
                    />
                    <div className="form-error">
                        <span className="formFieldError" id="cardNumber"></span>
                    </div>
                </Col>
            </Row>

            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <Paymentinput
                        id="expiry-month"
                        type="number"
                        label="Expiry Month"
                        aria_label="two digit expiry month"
                        placeholder="Enter Expiry Month"
                        tab_index="3"
                    />
                    <div className="form-error">
                        <span
                            className="formFieldError"
                            // className="control-label"
                            id="expiryMonth"
                        ></span>
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <Paymentinput
                        id="expiry-year"
                        type="number"
                        label="Expiry Year"
                        aria_label="two digit expiry year"
                        placeholder="Enter Expiry Year"
                        tab_index="4"
                    />
                    <div className="form-error">
                        <span
                            className="formFieldError"
                            // className="control-label"
                            id="expiryYear"
                        ></span>
                    </div>
                </Col>
            </Row>

            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                    className="horizontal-container-element"
                >
                    <Paymentinput
                        id="security-code"
                        type="text"
                        label="Security Code"
                        aria_label="three digit CCV security code"
                        placeholder="Enter Security Code"
                        tab_index="5"
                    />
                    <div className="form-error">
                        <span className="formFieldError" id="securityCode"></span>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default PaymentForm;
